import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';

// Components
import Header from './components/Header.tsx';
import Footer from './components/Footer.tsx';
import ScrollToTop from './components/ScrollToTop.tsx';

// Pages
import Home from './pages/Home.tsx';
import About from './pages/About.tsx';
import Services from './pages/Services.tsx';
import ServiceDetail from './pages/ServiceDetail.tsx';
import Offers from './pages/Offers.tsx';
import HowItWorks from './pages/HowItWorks.tsx';
import Contact from './pages/Contact.tsx';
import Testimonials from './pages/Testimonials.tsx';
import Clients from './pages/Clients.tsx';
import ClientDetail from './pages/ClientDetail.tsx';
import { OurWork } from './pages/OurWork.tsx';
import VideosAndReels from './pages/VideosAndReels.tsx';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="App min-h-screen bg-neutral-50 overflow-x-hidden">
        <Header />
        <AnimatePresence mode="wait">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/services/:service" element={<ServiceDetail />} />
            <Route path="/offers" element={<Offers />} />
            <Route path="/how-it-works" element={<HowItWorks />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/testimonials" element={<Testimonials />} />
            <Route path="/clients" element={<Clients />} />
            <Route path="/clients/:clientId" element={<ClientDetail />} />
            <Route path="/our-work" element={<OurWork />} />
            <Route path="/videos-reels" element={<VideosAndReels />} />
          </Routes>
        </AnimatePresence>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
